import { Component, OnInit } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatCard } from '@angular/material/card'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { ContractStatusService } from '../../../core/services/contract/contract-status/contract-status.service'
import { ContractStatusEditComponent } from '../../../features/contract/contract-status-edit/contract-status-edit.component'
import { ContractStatusCreateComponent } from '../../../features/contract/contract-status-create/contract-status-create.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'contract-status',
  imports: [
    FormSearchComponent,
    MatCard,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    ContractStatusCreateComponent,
    MatPaginatorModule,
  ],
  templateUrl: './contract-status.component.html',
  styleUrl: './contract-status.component.scss',
  providers: [ContractStatusService, AuthService],
  standalone: true,
})
export class ContractStatusComponent implements OnInit {
  constructor(
    private contractStatusService: ContractStatusService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]
  screen: string = 'status contrato'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }
  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.contractStatusService
      .listPagedContractStatus(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.contractStatusService
      .searchPagedContractStatus(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ContractStatusEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    console.log('item delete', item)
  }
}
